module.exports = __webpack_public_path__ + "img/2.29681894.jpg";